import { createStore } from "vuex";
import sound from "../assets/Pop.mp3";
import getCookie from "@/scripts/utils/getCookie.js";
import router from "@/router";

export default createStore({
    state: {
        hasDisplayed: false,
        keys: {},
        keys_item: [],
        errMsg: null,
        loader: null,
        web3: null,
        toggleMenu: false,
        authenticated: false,
        token_for_purchase: "DAI",
        networks: [],
        network: null,
        endpoints: {},
        fetchComp: false,
    },
    getters: {
        fetchComp(state) {
            return state.fetchComp;
        },
    },
    mutations: {
        toggleView(state) {
            state.showView = !state.showView;
        },
        toggleLoader(state) {
            state.loader = !state.loader;
        },
        emptyKeys(state) {
            state.keys_item = [];
        },
        authState(state, payload) {
            state.authenticated = payload;
        },
    },
    actions: {
        copyToClipBoard(commit, payload) {
            window.navigator.clipboard.writeText(payload);
            const copySound = new Audio(sound);
            copySound.play();
        },
        logout({ commit }) {
            commit("toggleLoader");
            fetch("/api/logout", {
                method: "POST",
                headers: {
                    "Content-type": "application/json",
                    "X-CSRFToken": getCookie("csrftoken"),
                },
            })
                .then((response) => {
                    return response.json();
                })
                .then((result) => {
                    if (result.ok) {
                        commit("authState", false);
                        commit("toggleLoader");
                        router.push({ name: "login" });
                    }
                    commit("emptyKeys");
                });
        },
    },
    modules: {},
});
